import React from "react";
import { Bubble } from "tea-component";
import NewFeatureBubble, {useFeatureBubbleProps} from "@/pages/datalab/components/NewFeatureBubble/index";

const NewFeatureBubbleWrap = (props: any) => {
  const {
    children,
    featureConfig,
    ...bubbleProps // 不展示新功能提示时, 展示什么内容
  } = props;
  
  const featureBubbleProps = useFeatureBubbleProps(featureConfig);
  
  return featureBubbleProps?.visible ? (<NewFeatureBubble {...featureBubbleProps}>{children}</NewFeatureBubble>) : (<Bubble {...bubbleProps}>{children}</Bubble>);
};

export default NewFeatureBubbleWrap;